<template lang="pug">
#background.bg-cover
  #background-overlay
section#login
  img.logo.center-block(src="./images/logo-white.png", height="50")
  form#login-form(@submit.prevent="login()")
    div.form-group(:class="{'has-error': input.email.error}")
      input.form-control.center-block(v-model="input.email.value", type="email", placeholder="EMAIL", name="email", required)
    div.form-group(:class="{'has-error': input.password.error}")
      input.form-control.center-block(v-model="input.password.value", type="password", placeholder="PASSWORD", name="password", required)
    button.btn.login-btn.center-block(type="submit") {{'LOGIN_BTN' | wordDict}}
      img(src="./images/btn-login.svg", height="50")
</template>

<script>
import axios from 'axios'
import router from './../../router'

export default {
  data () {
    return {
      input: {
        email: {
          value: '',
          error: false
        },
        password: {
          value: '',
          error: false
        },
      },
    }
  },
  computed: {},
  ready () {},
  watch: {
    '$root.user': (user) => {
      if (user !=  null)
        router.go('/downloads')
    },
    'input.email.value': function(val) {
      this.validateEmail()
    },
    'input.password.value': function(val) {
      this.validatePassword()
    }
  },
  methods: {
    login() {
      // if (!this.validateEmail()) {
      //   document.getElementById('login-form').email.focus()
      //   return false;
      // }
      // if (!this.validatePassword()) {
      //   document.getElementById('login-form').password.focus()
      //   return false;
      // }
      axios.post('/api/login', {
        email: this.input.email.value,
        password: this.input.password.value
      })
      .then((response) => {
        this.$root.user = response.data
      })
      .catch(function (error) {
        if (error.response) {
          console.log(error.response.data)
          alert(error.response.data.error_message)
        }
      });
    },
    validateEmail() {
      if (this.input.email.value == "") {
        this.input.email.error = true
        return false
      } else {
        this.input.email.error = false
        return true
      }
    },
    validatePassword() {
      if (this.input.password.value == "") {
        this.input.password.error = true
        return false
      } else {
        this.input.password.error = false
        return true
      }
    }
  },
  components: {}
}
</script>

<style lang="scss" scoped>
@import "global";

section {
  padding-left: 8px;
  padding-right: 8px;
  @media (max-width:$grid-float-breakpoint-max) {
    padding-top: 28px;
  }
  @media (min-width:$grid-float-breakpoint) {
    padding-top: 68px;
  }
}

img {
  background-color: transparent;
  &.logo { margin-bottom: 28px; }
}

#login {
  text-align: center;
  .form-group {
    @media (max-width:$grid-float-breakpoint-max) {
      margin-bottom: 8px;
    }
  }
  input {
    max-width: 360px;
    opacity: 0.8;
    border-radius: 4px;
    background-color: white;
    @media (max-width:$grid-float-breakpoint-max) {
      padding: 10px 20px 11px;
    }
    @media (min-width:$grid-float-breakpoint) {
      height: auto;
    }
    &,
    // &:-moz-placeholder,
    // &::-moz-placeholder,
    // &:-ms-input-placeholder,
    &::-webkit-input-placeholder {
      font-weight: bold;
      text-align: center;
      color: black;
      @media (max-width:$grid-float-breakpoint-max) {
        font-size: 14px;
        line-height: 19px;
      }
      @media (min-width:$grid-float-breakpoint) {
        font-size: 18px;
        // line-height: 30px;
      }
    }
  }
  .login-btn {
    font-size: 14px;
    color: white;
    font-weight: bold;
    margin-top: 18px;
    img {
      margin-left: 5px;
      width: 18px;
      height: 18px;
    }
  }
}

#background {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: -1;
  background-image: url('./images/img-login.jpg');
}
#background-overlay {
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0,0.4);
}

</style>


// WEBPACK FOOTER //
// user-login.vue?a3d6835a